module.exports = __webpack_public_path__ + "static/1312102723.74c93c7e.jpg";